export interface PositionModel<T extends number | null = number | null> {
  ts: string; // GPS time of last report received.
  lat: T; // number | null;
  lon: T; // number | null;
  hd: number | null; // heading
}

export const isPositionModelWithLatLng = (
  model?: PositionModel | null,
): model is PositionModel<number> => {
  return !!model && model.lat !== null && model.lon !== null;
};
